




















































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  dispatchType = "users/activities";

  columns: any[] = [
    {
      title: "时间",
      dataIndex: "created_time"
    },
    {
      title: "应用",
      scopedSlots: { customRender: "service" }
    },
    {
      title: "行为",
      dataIndex: "path"
    },
    {
      title: "行为分类",
      dataIndex: "ppath"
    },
    {
      title: "IP",
      dataIndex: "ip"
    },
    {
      title: "手机品牌",
      dataIndex: "brand_name"
    },
    {
      title: "型号",
      dataIndex: "device_model"
    },
    {
      title: "手机系统版本",
      dataIndex: "sys_version"
    },
    {
      title: "App版本",
      dataIndex: "app_version"
    }
  ];

  mounted() {
    console.log("mounted1");
    this.loadData(
      {
        user_id: this.userId
      },
      false
    );
  }
}
